export default "__VITE_ASSET__axtg89_s__"